module.exports = __webpack_public_path__ + "img/memory.403fe0f4.svg";